export const CustomerActivityTimelineSkeleton = () => {
  return (
    <div className="flex animate-pulse flex-col gap-4">
      <div className="text-skeleton h-8 w-full" />

      <div className="flex flex-col gap-2">
        <div className="text-skeleton h-4 w-2/3" />
        <div className="text-skeleton h-4 w-1/2" />
        <div className="text-skeleton h-4 w-2/3" />
        <div className="text-skeleton h-4 w-1/2" />
      </div>
    </div>
  );
};
